import {
  StoppageReasonResponseDto,
  StoppageReasonResponsible,
  StoppageReasonType,
  UpdateStoppageReasonCommand,
} from '@operations/app/api'
import { EventTypes } from '@operations/messages/eventsTypes'
import stoppageReasonService from '@operations/services/stoppageReasonService'
import { IEvent, IMessageBus } from '@tom-ui/utils'
import { BaseEntityStore } from './base/BaseEntityStore'

export interface StoppageReasonFormData {
  id?: number
  name: string
  shortName: string
  description: string | null
  type: StoppageReasonType | null
  responsible: StoppageReasonResponsible | null
}

export class StoppageReasonStore extends BaseEntityStore<StoppageReasonResponseDto> {
  fetchedAll = false

  constructor(private readonly messageBus: IMessageBus) {
    super()
    this.messageBus.subscribeEvent<StoppageReasonResponseDto>(
      EventTypes.StoppageReasonUpserted,
      this.handleUpsertedEvent,
    )
    this.messageBus.subscribeEvent<number>(
      EventTypes.StoppageReasonDeleted,
      this.handleDeletedEvent,
    )
  }

  public async fetchStoppageReasons() {
    if (this.fetchedAll) return

    const reasons = await stoppageReasonService.getStoppageReasons()
    this.updateStoreItems(reasons)

    this.fetchedAll = true
  }

  public async fetchStoppageById(id?: number) {
    if (!id || this.items.some(x => x.id === id)) return

    const reason = await stoppageReasonService.getById(id)
    this.updateStoreItem(reason, id)
  }

  private readonly handleUpsertedEvent = (res: IEvent<StoppageReasonResponseDto>) => {
    if (!res.payload) return

    this.updateStoreItem(res.payload, res.payload.id)
  }

  private readonly handleDeletedEvent = (res: IEvent<number>) => {
    if (!res.payload) return

    this.deleteStoreItem(res.payload)
  }

  public onSubmit = async (formData: StoppageReasonFormData) => {
    const commonFields = { ...formData, type: formData.type!, responsible: formData.responsible! }

    if (formData.id) {
      const cmd: UpdateStoppageReasonCommand = {
        ...commonFields,
        id: formData.id,
      }
      await stoppageReasonService.update(cmd)
    } else {
      await stoppageReasonService.create({ ...commonFields })
    }
  }

  public onDelete = async (id: number) => {
    await stoppageReasonService.delete(id)
  }
}
